<template>
  <IndexCompact :customers="customers" :balances="balances" :drafts="drafts" v-if="breakpoint=='xs'" />
  <IndexNormal :customers="customers" :balances="balances" :drafts="drafts" v-else />
</template>


<script>
  import IndexCompact from '@/views/customers/partners/nile_ug/IndexCompact';
  import IndexNormal from '@/views/customers/partners/nile_ug/IndexNormal';

  export default {
    components: { IndexCompact, IndexNormal },
    props: ['customers', 'balances', 'drafts'],
    computed: {
      breakpoint() { return this.$vuetify.breakpoint.name; },
    },
  }
</script>
